<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{
      props.row.CustomerQty_ACT
    }}</a>
  </div>
</template>

<script>
import store from "../../../../store/index";
export default {
  name: "customerACT",
  show(ops) {
    store.dispatch("getAllCustomerACT", {
      empresaid: ops.row.Empresaid
    });
  }
};
</script>
